/**
 * Decode a JWT token to extract its payload
 * @param {string} token - The JWT token to decode
 * @returns {Object|null} The decoded payload or null if invalid
 */
export function decodeJWT(token) {
  if (!token) return null;

  try {
    // Split the token into its parts
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    // Decode the payload (second part)
    const payload = parts[1];
    // Replace URL-safe characters and pad if necessary
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - (base64.length % 4)) % 4);
    const decoded = atob(base64 + padding);

    return JSON.parse(decoded);
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
}

/**
 * Get feature flags from the current auth token
 * @param {Object} authTokens - The auth tokens object containing access_token
 * @returns {Array<string>} Array of feature flags
 */
export function getFeatureFlags(authTokens) {
  if (!authTokens?.access_token) return [];

  const decoded = decodeJWT(authTokens.access_token);
  return decoded?.feature_flags || [];
}

/**
 * Check if a specific feature flag is enabled
 * @param {Object} authTokens - The auth tokens object containing access_token
 * @param {string} flag - The feature flag to check
 * @returns {boolean} True if the flag is enabled
 */
export function hasFeatureFlag(authTokens, flag) {
  const flags = getFeatureFlags(authTokens);
  return flags.includes(flag);
}
